import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import { HttpService } from '@services/http.service';

import { EndpointParams } from '@models/utils/endpoint-params';
import { Video } from '@models/index';

@Injectable({
    providedIn: 'root'
})
export class VideosRecentService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'center', version: 1 };

    private videoSubject = new BehaviorSubject<Video[]>([]);
    private isLoadingSubject = new BehaviorSubject<boolean>(true);
    private dataStore: { videos: Video[] } = { videos: [] };

    readonly videos = this.videoSubject.asObservable();
    readonly isLoading = this.isLoadingSubject.asObservable();

    list(): void {
        this.loading(true);
        this.listRecent().subscribe(
            () => {
                this.next();
                this.loading(false);
            }
        );
    }

    private listRecent(): Observable<boolean> {
        return new Observable<boolean>(
            observable => {
                this.get('polaris/virtual/recent', this.defaultEndpointParams).subscribe(
                    res => {
                        if (res) {
                            this.dataStore.videos = [];
                            res.forEach((category: any) => {
                                this.dataStore.videos.push(new Video().build(category));
                            });
                        }
                        observable.next(true);
                    }, () => observable.next(false)
                );
            }
        );
    }

    private next(): void {
        this.videoSubject.next([ ...this.dataStore.videos ]);
    }

    private loading(value: boolean): void {
        this.isLoadingSubject.next(value);
    }
}
